import { adaptiveSource, adaptiveTypes, withinRange, type AdaptiveContext } from "./adaptive";

/** Chance that a Practice question replays a missed fact, when there is one to replay. */
export const REPLAY_CHANCE = 0.25;

export { withinRange };

/** The types Practice draws from. See adaptiveTypes. */
export const practiceTypes = adaptiveTypes;

export type PracticeContext = AdaptiveContext;

/**
 * Practice questions: the child's rank band mix, weighted towards weak types
 * at full strength, with missed facts replayed now and then. Adaptive by
 * design; trials never are.
 */
export function practiceSource(ctx: PracticeContext) {
  return adaptiveSource(ctx, { replayChance: REPLAY_CHANCE, strength: 1 });
}
